import { createFileRoute } from '@tanstack/react-router'
import { JudgeProfileView } from '@workspace/seedforge-ui/evaluation'
import { Loader2 } from 'lucide-react'
import { InvestorLayout } from '../../../../components/investor-layout'
import { useInvestorJudgeProfileQuery } from '../../../../hooks/api'
import { useBasePath } from '../../../../hooks/use-base-path'

export const Route = createFileRoute('/app/investor/$id/judge/$judgeKey/$evaluationId')({
  component: InvestorJudgePage,
})

function InvestorJudgePage() {
  const { id: investorId, judgeKey, evaluationId } = Route.useParams()
  const basePath = useBasePath()
  const { data, isLoading, error } = useInvestorJudgeProfileQuery(
    investorId,
    evaluationId,
    judgeKey
  )

  if (isLoading) {
    return (
      <InvestorLayout activeNav="Feed">
        <div className="flex h-64 items-center justify-center">
          <Loader2 className="size-6 animate-spin text-muted-foreground" />
        </div>
      </InvestorLayout>
    )
  }

  if (error || !data?.data) {
    return (
      <InvestorLayout activeNav="Feed">
        <div className="flex h-64 items-center justify-center text-muted-foreground">
          Judge not found
        </div>
      </InvestorLayout>
    )
  }

  return (
    <InvestorLayout activeNav="Feed">
      <JudgeProfileView judge={data.data} backTo={`${basePath}/evaluation/${evaluationId}`} />
    </InvestorLayout>
  )
}
